import { render, staticRenderFns } from "./Headpro.vue?vue&type=template&id=385b2254&scoped=true&"
import script from "./Headpro.vue?vue&type=script&lang=js&"
export * from "./Headpro.vue?vue&type=script&lang=js&"
import style0 from "./Headpro.vue?vue&type=style&index=0&id=385b2254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385b2254",
  null
  
)

export default component.exports